<style scoped>
	@import '../../assets/css/nofound.css';
</style>

<template>
	<div class="unfound-container">
		<div class="unfound-background"></div>
		<div class="unfound-box">
			<h1>404</h1>
			<p>{{$t('msg.page_nofound')}}</p>
			<button type="button" @click="goHome()">{{$t('button.go_home')}}</button>
		</div>
	</div>
</template>

<script>
	import {getLocalStorage} from '@/system/store/localstorage';
	import {getTokenByName} from '@/system/store/cookie';
	
	export default{
		inject:['preloader'],
		data(){
			return '';
		},methods:{
			goHome(){
				if(getTokenByName('auth_sign_token')){
					this.$router.push('/home');
				}else{
					this.$router.push('/');
				}
			}
		},created:function(){
			var currentLang = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
			this.$i18n.locale = this.currentLang = currentLang;
			this.preloader(false);
		}
	}
</script>